import {
  BoxExpand,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { dateFormat } from 'src/common/helpers/date.helpers';
import { IProject } from 'src/pages/projects/projects.interfaces';
import { displayAddress } from 'src/common/helpers/common.helpers';

import { InfoContainer, InfoBlock, InfoElement } from './project-details-info.styles';
import TaskListView from './components/task-list-view.component';

const ProjectDetailsInfo = ({ project }: { project: IProject }) => {
  const { t } = useTranslation(['common', 'projects', 'customers']);
  const {
    name,
    customer,
    projectNumber,
    ownerMember,
    deputyMember,
    plannedHours,
    details,
    gantts = [],
    address,
    tasks,
    startDate,
  } = project;

  return (
    <>
      <InfoContainer>
        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectName')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{name}</Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectNumber')}:</Typography>
            {projectNumber && (
              <Typography
                fontColor={PLATFORM_THEME_COLORS.primary.grey}
              >{`№${projectNumber}`}</Typography>
            )}
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectPlannedHours')}:</Typography>
            <Typography
              fontColor={PLATFORM_THEME_COLORS.primary.grey}
            >{`${plannedHours} hr`}</Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectStartDate')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {dateFormat(startDate)}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectDetails')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{details || '-'}</Typography>
          </InfoElement>
        </InfoBlock>
        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">{t('common:labels.gantt')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {gantts.map(({ name }) => name).join(', ')}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('customers:labels.customerName')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {customer?.deleted
                ? t('customers:labels.customerNameDeleted', { name: customer?.name })
                : customer?.name}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectOwner')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {ownerMember?.profile.firstName} {ownerMember?.profile.lastName}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectOwnerDeputy')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {deputyMember?.profile.firstName} {deputyMember?.profile.lastName}
            </Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:labels.projectAddress')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {displayAddress(address || {})}
            </Typography>
          </InfoElement>
        </InfoBlock>
      </InfoContainer>
      <div>
        {tasks?.map(task => (
          <BoxExpand
            key={task._id}
            separator
            title={task.name}
            titleFontSize={TYPOGRAPHY_SIZE.medium}
            subTitle={`${task.timeStripes.length} ${t('projects:labels.timeStripe')}`}
          >
            <TaskListView task={task} />
          </BoxExpand>
        ))}
      </div>
    </>
  );
};

export default ProjectDetailsInfo;
